'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var wasKeypressEnter = function wasKeypressEnter(e) {
    return wasKeypress(e, 13);
};

var wasKeypress = exports.wasKeypress = function wasKeypress(e, value) {

    //check if e even exists
    if (e === null) {
        return false;
    }

    //if this doesn't exist it probably isn't a keypress
    if (typeof e.which === 'undefined') {
        return false;
    }

    if (e.which !== value) {
        return false;
    }

    //if it makes it here it was probably enter
    return true;
};

exports.default = wasKeypressEnter;